<template>
    <b-card class="border-0 h-100" body-class="d-flex flex-column justify-content-between align-items-middle">
        <div>
            <p style="text-align: center; font-size: 44px; color: #cbd5e1" class="my-4"><font-awesome-icon :icon="icon" v-if="!hasContentSharesV2Enabled"/></p>
            <p style="text-align: center; font-size: 44px; color: #6C757D" class="my-4" v-if="hasContentSharesV2Enabled">
              <social-media size="3x"/>
              <font-awesome-icon icon="long-arrow-alt-right"/>
              <font-awesome-icon v-if="customIcon === 'fa-building'" icon="building"/>
              <real-links-logo v-if="customIcon === 'rl-logo'" size="3x"/>
            </p>
            <p style="font-size: 15px" class="pt-4">{{ description }}</p>
        </div>
        <b-button variant="outline-primary" class="mt-4" pill block @click="$event => $emit('click', $event)">{{ buttonText }}</b-button>
    </b-card>
</template>

<script>
import { SocialMedia, RealLinksLogo } from '@src/components/Icons';
import { mapPreferences } from '@src/mixins/root';

export default {
  props: {
    icon: {
      type: String,
      default: '',
    },
    customIcon: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    buttonText: {
      type: String,
      default: '',
    },
  },
  components: {
    SocialMedia,
    RealLinksLogo
  },
  computed: {
    ...mapPreferences([ 'featuresEnabled' ]),
    hasContentSharesV2Enabled() {
      return (this.featuresEnabled || []).includes('content-share-v2');
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/content-share/content-share-editor/OptionBlock.vue